import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function docAttachment(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M3.71428571,0 L19.4728228,0 C20.1821923,1.83200525e-15 20.8686131,0.251368623
        21.4102217,0.709479176 L30.9373989,8.76788321 C31.6113064,9.33789667 32,10.1757565
        32,11.058404 L32,36.1666667 L32,36.1666667 C32,39.7477502 31.9591043,40 28.2857143,40
        L3.71428571,40 C0.0408957472,40 0,39.7477502 0,36.1666667 L0,3.83333333 C0,0.252249789
        0.0408957472,0 3.71428571,0 Z"
        fill="#D5E0FD"
        fillRule="nonzero"
      />
      <rect fill="#3D50DF" x="4" y="21" width="15" height="3" rx="1.5" />
      <rect fill="#3D50DF" x="4" y="27" width="13" height="3" rx="1.5" />
    </SvgIcon>
  );
}
